<template>
  <div class="desktop">
    <div class="header">
      <div class="content">
        <a class="logo" :href=globalConfig.olakkLogo target="_blank">
          <img src="/static/img/desktop/header_kk_logo.png" alt="logo"/>
        </a>
        <div class="menu">
          <a
            v-for="(menu, index) of menuList"
            :key="index"
            :href="menu.link"
            target="_blank"
          >{{ menu.label }}</a
          >
        </div>
        <div class="follow" v-if="$root.currentType !== 'curacao'">
          <a
            target="_blank"
            href="https://www.facebook.com/kkpokerglobal/?utm_source=KKpokerwebsite&utm_medium=websiteFB&utm_campaign=KKpokerwebsite"
          >
            <img
              class="facebook-img"
              src="/static/img/desktop/header_FB_icon.png"
            />
          </a>
          <a
            target="_blank"
            href="https://www.instagram.com/kkpokerglobal/?utm_source=KKpokerwebsite&utm_medium=websiteIG&utm_campaign=KKpokerwebsite"
          >
            <img
              class="ins-img"
              src="/static/img/desktop/header_Inst_icon.png"
            />
          </a>
          <a
            target="_blank"
            href="https://twitter.com/kkpokerglobal?utm_source=KKpokerwebsite&utm_medium=websitetwitter&utm_campaign=KKpokerwebsite"
          >
            <img
              class="twitter-img"
              src="/static/img/desktop/header_Twitter_icon.png"
            />
          </a>
        </div>
      </div>
    </div>

    <div class="container" ref="specificBackground">
      <div class="main-block">
        <div class="left-section">
          <img ref="specificHeader"/>
        </div>
        <div class="right-section">
          <div class="register-block settingHeight">
            <registerForm :isOlakk="true" :platform="platform"></registerForm>
          </div>
          <div class="download-block">
            <img
              class="title"
              src="/static/img/desktop/br_ld_title_white.png"
            />
            <div class="icon-link">
              <download-button
                :isOlakk="true"
                @setPlatform="platform = $event"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="olakk-modal"
      :class="{ show: showTutorial }"
      ref="olakkModal"
      @click="openTutorial"
    >
      <img class="pc" src="/static/img/desktop/KK-download.jpg"/>
      <img class="mb" src="/static/img/desktop/KK-download-mb.jpg" alt=""/>
    </div>

    <div class="payment-block">
      <div class="content">
        <img src="/static/img/desktop/payment_icons.png"/>
      </div>
    </div>

    <!-- <div class="mission-block">
      <div class="logo-section">
        <a target="_blank" href="https://kkpoker.news/bdcbblog">
          <img class="logo" ref="missionTitle"/>
        </a>
      </div>
      <div class="mission-section">
        <div class="col"><img src="/static/img/mission/01.jpg?t=20220117" /></div>
        <div class="col"><img src="/static/img/mission/02.jpg?t=20220117" /></div>
      </div>
      <div class="mission-section full-width">
        <img src="/static/img/mission/03.jpg" />
      </div>
    </div> -->

    <div class="terms">
      <div class="content" v-if="$root.currentType==='mannin'">
        <p>
          Os produtos e serviços oferecidos pelo KKPoker (por meio de seus sites
          e aplicativos para dispositivos móveis) são referidos coletivamente
          como “Serviços”.
        </p>
        <p>
          O acesso aos Serviços pode não ser legal para residentes ou pessoas
          localizadas em
          <a
            :href="globalConfig.noticeCountries"
            target="_blank"
          >
            determinados países
          </a>
          . Os serviços fornecidos aqui não constituem oferta, solicitação ou convite
          do KKPoker para o uso ou assinatura de: apostas, jogos de azar ou
          outros serviços em qualquer jurisdição em que tais atividades sejam
          proibidas por lei. Particularmente, residentes ou pessoas localizadas
          nos Estados Unidos não devem usar nenhum dos nossos Serviços.
        </p>
        <p>
          O KKPoker é uma marca e um nome comercial registrados e exclusivos da
          KKPoker, 49 Victoria Street, Douglas, Ilha de Man, IM1 2LD.
        </p>
        <p>
          Regulado e licenciado pela Comissão de Supervisão de Jogos da Ilha de
          Man de acordo com a Lei de Regulamentação de Jogos On-line de 2001,
          desde 24 de julho de 2019 (Última renovação: 24 de julho de 2019).
          Menores de 18 anos não estão autorizados a criar contas e/ou
          participar dos jogos. Quaisquer depósitos ou ganhos com o KKPoker são
          seguros e podem ser aplicados pela lei da Ilha de Man.
        </p>
      </div>
      <div class="content" v-else>
        <p>
          Os produtos e serviços que o KKPoker Global oferece (através de seus sites, tablet e aplicativos móveis) são
          referidos como “Serviços”.
        </p>
        <p>
          O acesso aos Serviços pode não ser legal para residentes ou pessoas localizadas em
          <a
            :href="globalConfig.noticeCountries"
            target="_blank"
          >
            determinados países
          </a>
          . Os Serviços fornecidos neste documento não constituem oferta,
          solicitação ou convite do KKPoker Global para o uso ou assinatura de apostas,
          jogos ou outros serviços em qualquer jurisdição na qual tais atividades sejam proibidas por lei.
          Em particular, residentes ou pessoas localizadas nos Estados Unidos não devem usar nenhum dos Serviços.
        </p>
        <p>
          O kkpoker.co é operado pela Violet Fortune Tech Limited N.V. registrada sob o número 158923 em Perseusweg 27A,
          Willemstad, Curaçao. Este site é licenciado e regulamentado pela Curaçao eGaming
          (licença de Curaçao nº 1668 JAZ emitida pela Curaçao eGaming).
        </p>
        <p>
          Pessoas menores de 18 anos não estão autorizadas a criar contas nem participar de jogos com apostas.
          Quaisquer depósitos ou ganhos com o KKPoker Global estão seguros e garantidos pela lei de Curaçao.
        </p>
      </div>
    </div>

    <div class="footer">
      <div class="content">
        <strong class="copyright">
          Copyright © {{ currentYear }} KKPoker. All Rights Reserved.
        </strong>
        <div class="jump_btn">
          <a
            v-if="globalConfig.iconHref"
            target="_blank"
            :href=globalConfig.iconHref
          ><img class="icon_06" :src="globalConfig.icon"
          /></a>
          <a
            target="_blank"
            href="https://access.gaminglabs.com/Certificate/Index?i=429"
          ><img class="icon_07" src="/static/img/home/gli.jpeg"
          /></a>
          <a target="_blank" href="https://www.gamcare.org.uk/"
          ><img class="icon_08" src="/static/img/home/icon_08.png"
          /></a>
          <a target="_blank" href="https://www.begambleaware.org/"
          ><img class="icon_09" src="/static/img/home/GambleAware.png"
          /></a>
          <a><img class="icon_10" src="/static/img/home/icon_10.png"/></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DownloadButton from '../components/downloadButton.vue'
import registerForm from '@/components/registerForm.vue'
import { setClubBannerImage } from '../configs/clubs'
import { uploadTrack } from '../configs/userStatsTrack'

/**
 * only show on olakk desktop with lang pt
 */
export default {
  name: 'olakk-desktop',
  components: { DownloadButton, registerForm },
  data () {
    return {
      platform: '',// temporarily abandoned
      currentYear: new Date().getFullYear(),
      showTutorial: false
    }
  },
  computed: {
    menuList () {
      return this.globalConfig.menuList
    }
  },
  methods: {
    openTutorial () {
      this.$refs.olakkModal.scrollTop = 0
      this.showTutorial = !this.showTutorial
    },
    track (deviceType) {
      const category = 'SignUp Special PC'
      this.$gtag.event('Click', {
        event_category: category,
        event_label: `Download ${deviceType}`
      })
      // upload track data to aliyun
      uploadTrack(this)
    }
  },
  mounted () {
    const code = this.$route.params.invitecode.toLocaleLowerCase()
    const path = '/static/img/desktop/'
    const obj = setClubBannerImage(code)
    this.$refs.specificBackground.style.backgroundImage = `url('${path}${obj.bg}')`
    this.$refs.specificHeader.src = path + obj.src
    // this.$refs.missionTitle.src = path + obj.logoTitle
  }
}
</script>

<style lang="less" scoped>
.container {
  display: block;
  position: relative;
  width: 100%;
  height: 80vh;
  // background-image: url("/static/img/desktop/header_banner.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  padding: 10px 20px;
  background: rgba(0, 0, 0, 0.8);

  .content {
    margin: 0 auto;
    max-width: 1600px;
    height: 60px;
    display: flex;
    flex-direction: row;
  }

  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;

    img {
      height: 100%;
    }
  }

  .menu {
    display: flex;
    justify-content: center;
    align-items: center;

    a {
      display: block;
      color: #f2f2f2;
      text-align: center;
      padding: 10px 20px;
      text-decoration: none;
      font-size: 25px;
      font-weight: bold;
      text-transform: uppercase;

      &:hover {
        border-bottom: 3px solid #219655;
      }
    }
  }

  .follow {
    margin-left: auto;
    display: flex;
    justify-content: center;
    align-items: center;

    .title {
      margin-bottom: 20px;
      color: #8a8a8a;
      font-size: 18px;
    }

    img {
      display: inline-block;
    }

    a {
      display: inline-block;
      margin-right: 48px;
      vertical-align: middle;
    }

    .facebook-img {
      width: 24px;
    }

    .ins-img {
      width: 38px;
    }

    .twitter-img {
      width: 47px;
    }
  }
}

.main-block {
  margin: 0 auto;
  max-width: 1600px;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;

  .left-section {
    height: 85%;
    position: absolute;
    left: 2%;
    bottom: 0;

    img {
      height: 100%;
    }

    @media only screen and (max-width: 970px) {
      top: 10%;
      height: 75%;
    }
  }

  .right-section {
    margin-left: 50%;
  }
}

.payment-block {
  background-image: url('/static/img/desktop/specific/payment/paymentBackground.jpg');
  background-repeat: no-repeat;
  background-size: cover;

  .content {
    margin: 0 auto;
    max-width: 1600px;
    padding: 20px;

    img {
      display: block;
      width: 100%;
    }
  }
}

.mission-block {
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .logo-section {
    width: 100%;
    padding: 40px;
    background-image: url('/static/img/desktop/specific/title/title_back.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;

    .logo {
      width: 80%;
      max-width: 1680px;
    }
  }

  .mission-section {
    margin: 40px auto 0;
    max-width: 1600px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;

    &.full-width {
      margin-top: 0;
      margin-bottom: 40px;
      flex-direction: column;
    }

    .col {
      width: 50%;
      padding: 20px;
    }

    img {
      width: 100%;
      height: auto;
    }
  }
}

.right-section {
  display: flex;
  width: fit-content;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 200px 150px;
  z-index: 9;
  margin-top: 7%;

  @media screen and (max-width: 1000px) {
    margin: 0 auto;
  }

  * {
    box-sizing: border-box;
  }

  .register-block {
    margin: -10% 0;
    transform: scale(0.8);
    width: 850px;
    height: 780px;
    overflow: hidden;
    border: 5px solid #d2cdd1;
    background-color: #151515;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  }

  .download-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .title {
      margin: 20px 0;
      width: 700px;
    }

    .icon-link {
      white-space: nowrap;

      a {
        cursor: pointer;
      }

      img {
        margin: 10px 15px;
        width: 330px;
      }
    }
  }
}

.terms {
  padding: 100px 0;

  .content {
    margin: 0 auto;
    max-width: 1600px;
  }

  p {
    color: #fff;
    font-size: 20px;
    line-height: 1.5;
    margin-bottom: 32px;
  }

  a {
    color: #219655;
    box-shadow: 0 1px;
    font-size: 20px;
    text-decoration: none;
  }
}

.footer {
  width: 100%;
  background: rgba(0, 0, 0, 1);

  .content {
    border-top: 1px solid #353535;
    padding: 10px 0;
    margin: 0 auto;
    max-width: 1600px;
    height: 70px;
    display: flex;
    align-items: center;
    flex-direction: row;
  }

  .copyright {
    color: rgb(140, 140, 140);
    font-size: 25px;
    font-weight: bold;
  }

  .jump_btn {
    margin-left: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;

    a {
      display: inline-block;
      margin: 0 10px;
      // cursor: pointer;
    }

    img {
      display: inline-block;
      vertical-align: middle;
      // margin: 0px 16px;
    }

    .icon_06 {
      width: 76px;
    }

    .icon_07 {
      width: 97px;
    }

    .icon_08 {
      width: 89px;
    }

    .icon_09 {
      width: 165px;
    }

    .icon_10 {
      width: 48px;
    }
  }
}

.olakk-modal {
  display: none;
  position: fixed;
  text-align: center;
  z-index: 11;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.7);

  .mb {
    display: none;
  }

  img {
    width: 90%;
    margin: 5% 0;
  }

  @media only screen and (max-width: 767px) {
    .pc {
      display: none;
    }

    .mb {
      display: inline-block;
    }
  }

  &.show {
    display: block;
  }
}
</style>
<style lang="less">
// overwrite register component
.register-block {
  .top,
  .my-swipe,
  .float_bottom {
    display: none;
  }
}
</style>
